// --- React
import React from 'react';
// --- UI Components
import { Col, Row } from 'antd';
import Typography from '@dtci/spellbook/Typography';
// --- Utilities
import { getLoadDetails } from '../utils/getDetailsData';
// --- Styles
import '../../styles.scss';

/**
 * LoadCard Component
 *
 * This component is responsible for rendering a card that displays detailed
 * information about a product's load status.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.details - The details of the product to be displayed.
 * @returns {JSX.Element} Load card with detailed information.
 */
export function LoadCard({ details }) {
    // Function to extract load details from the provided data
    const loadDetails = getLoadDetails(details);

    return (
        <Row style={{ marginTop: 20 }}>
            <Col>
                {loadDetails.map(({ label, value }, idx) => (
                    <Row key={`load-detail-${idx}`}>
                        <Typography variant="T20">
                            <b>{label}:</b>
                            <br />
                            {value}
                        </Typography>
                    </Row>
                ))}
            </Col>
        </Row>
    );
}
